import { PersonProfilePictureAvatar } from "../routes/app/-components/person-profile-picture-avatar"
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"

interface Props {
  userId: number
}

export function UserAvatar({ userId }: Props) {
  const { data: user } = useSuspenseQueryGet("/api/User/GetSimpleUser", {
    includePerson: true,
    userId,
  })

  return <PersonProfilePictureAvatar personId={user.person?.personId ?? 0} />
}
